const getFavourites = (store) => {
	return store.Session.favourites;
};

export default getFavourites;
